export default __webpack_public_path__ + "static/media/whale3.55b9f7b0.png";